export const iconFontAwesomeGamingDungeon = (
	<i className="fa-solid fa-dungeon"></i>
);
